import React, {Component} from 'react'
import classNames from "classnames"
import {Divider, Icon, Modal} from 'antd'
import PropTypes from "prop-types"
import ItemStatus from "./ItemStatus"
import {Link} from "react-router-dom"

class ItemQC extends Component {
    state = {
        visible: false,
    }

    _showModal = (e) => {
        e.stopPropagation();
        this.setState({
            visible: true,
        })
    }

    _hideModal = (e) => {
        this.setState({
            visible: false,
        })
    }

    _handleChangeChecked = (isCheckError) => {
        if(isCheckError) return
        const {item, updateOrdersSelected} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item

            if (!item.can_qc_completed) return

            const {_id: orderID} = tool3d_order

            const isChecked = this._detectChecked()

            updateOrdersSelected(orderID, !isChecked)
        }
    }

    _detectChecked = () => {
        const {item, arrChecked} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item
            const {_id: orderID} = tool3d_order

            return arrChecked.includes(orderID)
        }
    }

    _handleCheckError = (isCheckSelected) => {
        if(isCheckSelected) return
        const {item, handleCheckError} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item

            if (!item.can_qc_completed) return

            const {_id: orderID} = tool3d_order

            const isChecked = this._detectCheckedError()

            handleCheckError(orderID, !isChecked)
        }
    }

    _detectCheckedError = () => {
        const {item, arrCheckError} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item
            const {_id: orderID} = tool3d_order

            return arrCheckError.includes(orderID)
        }
    }



    render() {
        const {visible} = this.state
        const {item, defaultChecked} = this.props
        const {cannot_qc_completed_reason, can_qc_completed, meta = {}} = item
        const {__safeZoneImage : safezone_image} = Object.assign({}, meta)
        const {type, size} = item
        const isChecked = this._detectChecked()
        const isCheckError = this._detectCheckedError()
        const isDefaultChecked = (defaultChecked !== undefined && defaultChecked.length > 0) ? defaultChecked.includes(item._id) : false

        let is3d = item
        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }

        const showSafeZone = () => {
            if (!!safezone_image) {
                return <img src={safezone_image} alt="SafeZone" className="Safezone"/>
            }
        }

        return (
            <>
                <div className={classNames((isChecked || isDefaultChecked) ? 'position-relative itemChecked' : 'position-relative')}>
                    <div className={`ImagePreview position-relative cursor-pointer ${isCheckError ? 'itemCheckedError' : ''}`} onClick={() => this._handleChangeChecked(isCheckError)}>
                        <img src={['GIFTCARD_1800NO'].includes(type) ? is3d.mock_up_front : is3d.preview_image || is3d.designFront} className='previewImage' alt='preview'/>
                        
                        {
                            showSafeZone()
                        }

                        {
                            (!can_qc_completed && cannot_qc_completed_reason !== null) &&
                            <strong className="ErrorText text-danger">
                                {
                                    (!!cannot_qc_completed_reason && cannot_qc_completed_reason.includes("đã được đánh dấu lỗi!")) ? "error" :
                                        (!!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch && cannot_qc_completed_reason.length > 0) ?
                                            is3d.batch_item.status : cannot_qc_completed_reason
                                }
                            </strong>
                        }
                        <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                            <span className='Icon cursor-pointer mr-2' onClick={this._showModal}><Icon
                                type='eye'/></span>
                        </div>
                    </div>
                    <Divider style={{'marginBottom': 5, marginTop: 5}}/>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center">
                                {
                                    !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch &&
                                    <ItemStatus status={is3d.batch_item.status}/>
                                }
                                <div className="size badge badge-secondary badge-pill ml-2" style={{fontSize:'14px'}}>{size}</div>
                                <div className="number badge badge-secondary badge-pill ml-2">{is3d.item_number}</div>
                            </div>
                            <div><strong>{item.type}</strong></div>
                        </div>
                        {!isDefaultChecked && <div className="infoImage d-flex">
                            <div onClick={() => this._handleChangeChecked(isCheckError)}
                                className={`checked text-primary cursor-pointer ${(isChecked || isDefaultChecked) ? '' : 'opacity-50'}`}>
                                <i className="fa fa-check-circle fa-3x" />
                            </div>
                            <div onClick={() => this._handleCheckError(isChecked)}
                                className={`checked text-danger cursor-pointer ${isCheckError ? '' : 'opacity-50'}`}>
                                <i className="fa fa-times-circle fa-3x ml-3" />
                            </div>
                        </div>}
                    </div>
                    {/* {!isDefaultChecked && <div className="infoImage">
                        <div onClick={() => this._handleChangeChecked(isCheckError)}
                        className={`checked position-absolute text-primary cursor-pointer ${(isChecked || isDefaultChecked) ? '' : 'opacity-75'}`}>
                            <i className="fa fa-check-circle fa-3x"/>
                        </div>
                        <div onClick={() => this._handleCheckError(isChecked)}
                        className={`checked position-absolute text-danger ml-4 cursor-pointer ${isCheckError ? '' : 'opacity-75'}`}>
                            <i className="fa fa-times-circle fa-3x ml-3"/>
                        </div>
                    </div>} */}
                    {
                        !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch &&
                        <div title="Tên lô" className="BatchInfo">
                        <span><Link
                            to={`/batches/${is3d.batch_item.batch._id}`}>{is3d.batch_item.batch.name}</Link></span>
                        </div>
                    }
                </div>

                <Modal visible={visible} closable={false} centered={true} footer={null}
                       onCancel={this._hideModal} className='modal-custom-width PrintedFileModal'>
                    <div className="Previewer">
                        <img src={['GIFTCARD_1800NO'].includes(type) ? is3d.mock_up_front : is3d.preview_image} alt='preview' className='d-block m-auto'/>
                        {
                            showSafeZone()
                        }
                    </div>
                </Modal>
            </>
        )
    }
}

ItemQC.propTypes = {
    item: PropTypes.object.isRequired,
    arrChecked: PropTypes.array,
    updateOrdersSelected: PropTypes.func.isRequired,
}

export default ItemQC
